// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"204":"8182d610","311":"56c13ef3","710":"85f6b7b9"}[chunkId] + ".chunk.css";
};